import { ADD, ADD_CHILD, REMOVE, REPLACE, CLEAR_FORM_STATE } from "../actions/applicationType";

const initialState = {};

const applicationreducers = (state = initialState, action) => {
  const { type, payload, parentKey, propertyKey } = action;

  switch (type) {
    case CLEAR_FORM_STATE: {
      return {};
    }
    case REPLACE:
      return action.payload;
    case ADD:
      if (propertyKey) {
        return {
          ...state,
          [propertyKey]: Array.isArray(payload) ? [...payload] : payload
        };
      } else if (payload && typeof payload === "object") {
        return {
          ...state,
          ...payload
        };
      } else {
        return state;
      }

    case ADD_CHILD:
      return {
        ...state,
        [parentKey]: {
          ...state[parentKey],
          [propertyKey]: payload
        }
      };
    case REMOVE: {
      const tempState = { ...state };
      if (parentKey && tempState[parentKey]) {
        delete tempState[parentKey];
        if (propertyKey && tempState[parentKey] && tempState[parentKey][propertyKey]) {
          delete tempState[parentKey][propertyKey];
        }
      }

      return tempState;
    }
    default:
      return state;
  }
};

export default applicationreducers;
